import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
@Component({
  selector: 'app-implementation-guide',
  templateUrl: './implementation-guide.component.html'
})
export class ImplementationGuideComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getImplementationguidelabels();
  }
  guidecontent;
  gasblinkurl;
  header;
  getImplementationguidelabels() {
    this.graphQlService.getothersourceLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.guidecontent = labels.filter(x => x.key == "implementationguides").map(y => y.value);
        this.gasblinkurl = labels.filter(x => x.key == "implguidelink").map(y => y.value);
        this.header = labels.filter(x => x.key == "implementationguides_header").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }

 
  openLinkById(event) {
    event.target.href = this.gasblinkurl;

  }
  onRightClick(event) {
    event.target.href = this.gasblinkurl;
  }
}
